// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__j1Z9F","link_style":"styles_link_style__k5rNx","fade-out":"styles_fade-out__oHsBA","fade-in":"styles_fade-in__0Iisq"};